import { Component } from 'react';

import Dropdown from '../../components/ui/dropdown/dropdown';
import FeaturesTilesComponent from '../../components/ui/features-tiles/features-tiles.component';
import { MotiveComponent } from '../../components/ui/motive/motive.component';
import { AdSlots } from '../ui/motive/ad-slots';
import Tooltip from '../../components/ui/tooltip/tooltip.component';
import { IOC_TYPES } from '../../context/ioc.types';
import { lazyInject } from '../../context/module';
import { FileUpload } from '../../models/file-upload';
import { Logger } from '../../models/logger';
import { UploadInProgressFile, UploadInProgressFileFactory } from '../../models/upload-in-progress-file';
import { FileDownloadService } from '../../services/file-download.service';
import { FileShareService } from '../../services/file-share.service';
import { FileUploadService } from '../../services/file-upload.service';
import { MemeUploadService } from '../../services/meme-upload.service';
import { MotivesService } from '../../services/motives.service';
import { PageDataProviderService } from '../../services/page-data-provider.service';
import { ProcessorResolverService } from '../../services/processor-resolver.service';
import { ScriptLoadService } from '../../services/script-load.service';
import { SpinnerService } from '../../services/spinner.service';
import { UIContext } from '../../services/ui-context';
import { UploadedFilesService } from '../../services/uploaded-files.service';
import { WebSocketService } from '../../services/websocket.service';
import { MouseEventTypes } from '../../types/geo.types';
import { RouteProps, SeoFeature } from '../../types/route-types';
import { ConnectivityUtils } from '../../utils/connectivity.utils';
import { FromTypes, OperationTypes, OriginalInputFile, ProcessTypes } from '../../types/types';
import { UIUtils } from '../../utils/dom-utils';
import { FileUploadUtils } from '../../utils/file-upoad.utils';
import { IconHelper } from '../../utils/icon-helper';
import { HtmlEntityTypes } from '../../utils/icon.utils';
import { reloadAfterExecute, reloadAfterExecuteAsync } from '../../utils/react.utils';
import { MotiveLocationTypes } from '../../utils/request.utils';
import { WindowUtils } from '../../utils/window.utils';
import { cloneDeep, parseInt, range } from '../../utils/lodash-min';
import { FloatingSVGGraphic } from './clip-art';
import { ClipartSourceImage } from './clipart-source-image';
import { Meme } from './meme-generator';
import styles from './meme-generator.component.module.scss';
import { MemeSpaceImage, MemeStoredImage } from './meme-image';
import { MemeSourceImage } from './meme-source-image';
import { MemeText } from './meme-text';
import { Location, TextAlignType, TextAlignTypes } from './meme.types';
import { MemeShareModalComponent } from './share/meme-share-modal.component';
import { ClipartModalComponent } from './templates/clipart-modal.component';
import { MemeModalComponent } from './templates/meme-modal.component';
import MotiveFrame from '../motive-frames/motive-frame.component';
import sharedStyles from '../single-page-converters/single-page.module.scss';



export default class MemeGeneratorComponent extends Component<RouteProps> {
    private readonly logger = Logger.getLogger('MemeGeneratorComponent');

    public title: string;
    public description: string;
    public features: Array<SeoFeature>;

    public memeWidth = 700;

    public showHTML = false;
    public controllersShown = true;
    public isMobile: boolean;
    public fileUploadArray: FileUpload[];
    public scale = 1;

    meme: Meme;

    private selectedItem: any;
    private selectedItemTopLeftOffset: Location;
    private isResizeHandlerActive = false;
    private resizeHandlerType: MouseEventTypes.MouseEventType;

    public drawerType = undefined;

    private colorsDropdownItems = [
        { id: 'white', item: 'white', text: 'White', selected: false },
        { id: 'black', item: 'black', text: 'Black', selected: true },
        { id: 'red', item: 'red', text: 'Red', selected: false },
        { id: 'green', item: 'green', text: 'Green', selected: false },
        { id: 'blue', item: 'blue', text: 'Blue', selected: false },
        { id: 'yellow', item: 'yellow', text: 'Yellow', selected: false },
        { id: 'orange', item: 'orange', text: 'Orange', selected: false },
        { id: 'pink', item: 'pink', text: 'Pink', selected: false },
        { id: 'purple', item: 'purple', text: 'Purple', selected: false },
    ]
    private fontsDropdownItems = [
        { item: 'impact', id: 'impact', text: 'Impact (meme)', selected: true },
        { item: 'arial', id: 'arial', text: 'Arial', selected: false },
        { item: 'helvetica', id: 'helvetica', text: 'Helvetica', selected: false },
        { item: 'verdana', id: 'verdana', text: 'verdana', selected: false },
        { item: 'tahoma', id: 'tahoma', text: 'Tahoma', selected: false },
        { item: 'georgia', id: 'georgia', text: 'Georgia', selected: false },
        { item: 'Times New Roman', id: 'Times New Roman', text: 'Times New Roman', selected: false },
    ];

    private dropdownItemsCache = new Map();

    mouseMoveHandler: ($event) => void;
    addImagePanelShowForImage = null;
    borderPropertyPanelShownForImage = null;


    @lazyInject(UploadedFilesService) private uploadedFilesService: UploadedFilesService;
    @lazyInject(FileUploadService) private fileUploadService: FileUploadService;
    @lazyInject(MemeUploadService) private memeUploadService: MemeUploadService;
    @lazyInject(UIContext) private uiContext: UIContext;
    @lazyInject(FileDownloadService) private fileDownloadService: FileDownloadService;
    @lazyInject(FileShareService) private fileShareService: FileShareService;
    @lazyInject(ProcessorResolverService) private processorResolverService: ProcessorResolverService;
    @lazyInject(WebSocketService) private websocketService: WebSocketService;
    @lazyInject(MotivesService) public motiveService: MotivesService;
    @lazyInject(SpinnerService) private spinner: SpinnerService;
    @lazyInject(ScriptLoadService) private scriptLoadService: ScriptLoadService;
    @lazyInject(PageDataProviderService) private pageDataProviderService: PageDataProviderService;

    constructor(props: RouteProps) {
        super(props);
    }

    componentDidMount() {
        const value = this.props.pageData;
        this.features = value.page_seo.feature;
        this.title = value.page_seo.title;
        this.description = value.page_seo.description && value.page_seo.description.replace(/\s+/g, ' ');
        this.uploadedFilesService.initializeForCompatibility(value.fromType, value.accept);
        this.uploadedFilesService.notyfyAll();
        // Removed legacy mobile scaling
        this.initializeMemeSample();
        window.addEventListener('resize', this.updateScale);
        setTimeout(this.updateScale, 100);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateScale);
    }

    updateScale = () => {
        try {
            const container = document.querySelector('.meme-wrapper-col');
            if (container) {
                const width = container.getBoundingClientRect().width;
                const memeWidth = this.meme ? this.meme.getMemeWidth() : 700;
                // If container is smaller than meme, scale down. Max scale 1.
                this.scale = Math.min(1, (width - 40) / memeWidth); // 40px padding safety
                if (this.scale < 0.1) this.scale = 0.1;
                this.forceUpdate();
            }
        } catch (e) { console.error(e); }
    }

    @reloadAfterExecute()
    clearMeme() {
        this.meme = new Meme(this.memeWidth);
        const memeImage1 = new MemeStoredImage('/meme/src/placeholder.jpg', this.meme);

        Promise.all([this.meme.addImage(memeImage1)]).then(() => {
            this.meme.paint();
        });
    }

    @reloadAfterExecute()
    updateTextColor(memeText: MemeText, color: string) {
        memeText.fontColor = color;
        this.meme.paint();
    }

    @reloadAfterExecute()
    updateTextFamily(memeText: MemeText, fontFamily: string) {
        memeText.fontFamily = fontFamily;
        this.meme.paint();
    }

    @reloadAfterExecute()
    addNewText() {
        const text = new MemeText(
            `Double click for text editor.\n ...`,
            {
                width: this.memeWidth,
                x: 0,
                y: 100,
                z: 1,
            });

        this.meme.addText(text);
        this.meme.paint();
    }

    @reloadAfterExecute()
    addClipArt() {
        ClipartModalComponent.show({
            selectCallback: (memeSourceImage: ClipartSourceImage) => {
                FloatingSVGGraphic.createNew({
                    width: this.memeWidth,
                    x: 0,
                    y: 100,
                    z: 1,
                }, memeSourceImage.sourceImageUrl).then(graphic => {
                    this.meme.addGraphic(graphic);
                    this.meme.paint();
                });
                this.forceUpdate();
            },
        });
    }

    @reloadAfterExecute()
    toggleControls() {
        this.controllersShown = !this.controllersShown;
    }

    @reloadAfterExecute()
    changeImage(image: MemeStoredImage) {
        MemeModalComponent.show({
            selectCallback: (memeSourceImage: MemeSourceImage) => {
                this.meme.changeImageSrc(image, memeSourceImage.sourceImageUrl)
                    .then(() => {
                        //
                        this.forceUpdate();
                    });
            },
        });
    }

    @reloadAfterExecute()
    addImageAbove(image: MemeStoredImage) {
        MemeModalComponent.show({
            selectCallback: (memeSourceImage: MemeSourceImage) => {
                this.meme.addImageAbove(image, new MemeStoredImage(memeSourceImage.sourceImageUrl, this.meme))
                    .then(() => {
                        //
                        this.forceUpdate();
                    });
            },
        });
    }

    @reloadAfterExecute()
    addSpaceAbove(image: MemeStoredImage) {
        this.meme.addImageAbove(image, new MemeSpaceImage(this.meme, { width: this.memeWidth, height: 100 }, 'black'))
            .then(() => {
                //
                this.forceUpdate();
            });
    }

    @reloadAfterExecute()
    addImageBelow(image: MemeStoredImage) {
        MemeModalComponent.show({
            selectCallback: (memeSourceImage: MemeSourceImage) => {
                this.meme.addImageBelow(image, new MemeStoredImage(memeSourceImage.sourceImageUrl, this.meme))
                    .then(() => {
                        //
                        this.forceUpdate();
                    });
            },
        });
    }

    uploadCustomImage() {
        //
    }

    @reloadAfterExecute()
    updateImageBorderColor(image: MemeStoredImage, color) {
        image.setBackgroundColor(color);
        this.meme.paint();
    }

    @reloadAfterExecute()
    updateImageBorderTop(event: any, image: MemeStoredImage) {
        //
        image.setBorderTop(parseInt(event.target.value, 10));
        this.meme.paint();
    }

    @reloadAfterExecute()
    updateImageBorderBottom(event: any, image: MemeStoredImage) {
        //
        image.setBorderBottom(parseInt(event.target.value, 10));
        this.meme.paint();
    }

    @reloadAfterExecute()
    moveImageDown(image) {
        this.meme.swapWithBelow(image);
        this.meme.paint();
    }

    @reloadAfterExecute()
    moveImageUp(image) {
        this.meme.swapWithAbove(image);
        this.meme.paint();
    }

    @reloadAfterExecute()
    deleteImage(image) {
        try {
            this.meme.deleteImage(image);
        } catch (e) {
            this.uiContext.showErrorDialog(
                { title: 'Error', text: 'Can not delete this image. Meme should have at least one image. You may change the image.' });
        }
    }

    @reloadAfterExecute()
    updateTextAlign(memeText: MemeText, textAlign: TextAlignType) {
        memeText.textAlign = textAlign;
        this.meme.paint();
    }

    @reloadAfterExecute()
    deleteText(text) {
        this.meme.deleteText(text);
        this.meme.paint();
    }

    @reloadAfterExecute()
    deleteGraphic(graphic) {
        this.meme.deleteGraphic(graphic);
        this.meme.paint();
    }

    @reloadAfterExecute()
    capitalizeText(text: MemeText) {
        text.setCapitalized(!text.getCapitalized());
        this.meme.paint();
    }

    @reloadAfterExecute()
    toggleLineWidth(text: MemeText) {
        text.hasLineWidth = !text.hasLineWidth;
        this.meme.paint();
    }

    @reloadAfterExecute()
    showDrawerFor(type: string) {
        this.drawerType = type;
    }

    @reloadAfterExecute()
    fontPropertyChanged(event: any, memeText: MemeText) {
        const val = parseInt(event.target.value, 10);
        if (this.drawerType === 'FONT_SIZE') {
            memeText.setMaxFontSize(val);
            this.meme.paint();
        } else if (this.drawerType === 'FONT_GAP') {
            memeText.setFontGap(val);
            this.meme.paint();
        }
    }

    @reloadAfterExecute()
    contentChanged(event: KeyboardEvent, text: MemeText) {
        const textArea = event.target as HTMLTextAreaElement;
        // PSLogger.log(event);
        text.setText(textArea.value);
        this.meme.paint();
    }

    shouldIgnoreEvent(event: MouseEvent) {
        return UIUtils.hasParentWithCSSSelector(event.target as HTMLElement, '.text-editor,.static-handler');
    }

    @reloadAfterExecute()
    mouseDown(event: MouseEvent, item: any, type: MouseEventTypes.MouseEventType) {
        if (this.shouldIgnoreEvent(event)) {
            return;
        }
        const elRect: ClientRect = (event.target as HTMLElement).getBoundingClientRect();
        const ev = ((event as any).touches && (event as any).touches[0]) || event;
        const p: Location = {
            x: (elRect.left - ev.clientX) / this.scale,
            y: (elRect.top - ev.clientY) / this.scale,
        };
        this.isResizeHandlerActive = true;
        this.selectedItem = item;
        this.resizeHandlerType = type;
        this.selectedItemTopLeftOffset = p;
        this.meme.setSelectedItem(item, p);
        event.preventDefault();
        if (event.stopImmediatePropagation) {
            event.stopImmediatePropagation();
        }
        if (event.stopPropagation) {
            event.stopPropagation();
        }

        WindowUtils.addMoveMoveHandlerToWindow(($event) => this.mouseMove($event));
        WindowUtils.addMoveUpHandlerToWindow(($event) => this.mouseUp());
    }

    suppressEvent(event: MouseEvent) {
        event.preventDefault();
        if (event.stopImmediatePropagation) {
            event.stopImmediatePropagation();
        }
        if (event.stopPropagation) {
            event.stopPropagation();
        }
    }

    @reloadAfterExecute()
    mouseMove(event) {
        const ev = ((event as any).touches && (event as any).touches[0]) || event;
        if (this.isResizeHandlerActive && this.selectedItem) {
            const clientX = ev.clientX;
            const clientY = ev.clientY;
            if (this.resizeHandlerType === MouseEventTypes.RESIZE) {
                this.meme.resizeGraphicContainer(this.selectedItem, {
                    x: clientX,
                    y: clientY,
                }, this.scale);
            } else if (this.resizeHandlerType === MouseEventTypes.MOVE) {
                this.meme.moveGraphicContainer(this.selectedItem, {
                    x: clientX,
                    y: clientY,
                }, this.scale);
            } else if (this.resizeHandlerType === MouseEventTypes.ROTATE) {
                this.meme.rotateGraphicContainer(this.selectedItem, {
                    x: clientX,
                    y: clientY,
                }, this.scale);
            } else {
                this.logger.error({ message: 'Unknown event.' });
            }
            this.meme.paint();
        }
    }

    @reloadAfterExecute()
    updateEditMode($event, text: MemeText) {
        const state = text.getEditPanelState();
        this.meme.hideAllTextEditPanels();
        text.toggleEditPanel();
        if (state) {
            text.hideEditPanel();
        } else {
            text.showEditPanel();
        }
    }

    @reloadAfterExecute()
    mouseUp() {
        this.isResizeHandlerActive = false;
        this.selectedItem = undefined;
        this.meme.setSelectedItem(undefined, undefined);
    }

    /**
     * if call on keydown this will return the previous cursor position.
     * for keyup, this returns current position
     * @param editableDiv
     */
    getCaretPosition(editableDiv) {
        let caretPos = 0,
            sel, range;
        if (window.getSelection) {
            sel = window.getSelection();
            if (sel.rangeCount) {
                range = sel.getRangeAt(0);
                if (range.commonAncestorContainer.parentNode === editableDiv) {
                    caretPos = range.endOffset;
                }
            }
        } else if ((document as any).selection && (document as any).selection.createRange) {
            range = (document as any).selection.createRange();
            if (range.parentElement() === editableDiv) {
                const tempEl = document.createElement('span');
                editableDiv.insertBefore(tempEl, editableDiv.firstChild);
                const tempRange = range.duplicate();
                tempRange.moveToElementText(tempEl);
                tempRange.setEndPoint('EndToEnd', range);
                caretPos = tempRange.text.length;
            }
        }
        return caretPos;
    }

    async shareMeme() {
        await this.initializeScriptsAndWebsockets();
        const fileUpload = await this.uploadMeme();
        const inputFileLocation = fileUpload.originalInputFiles[0].location;
        this.fileShareService.shareGCSPermenentFile(fileUpload, inputFileLocation, 'meme.jpg', true)
            .then(data => {
                MemeShareModalComponent.show({
                    url: data.pageUrl,
                    downlaodFile: (title) => {
                        this.fileShareService.downloadMemeImageFile(data.imgUrl);
                    },
                });
            });
    }

    async downloadMeme() {
        await this.initializeScriptsAndWebsockets();
        try {
            const fileUpload = await this.uploadMeme();
            const inputFileLocation = fileUpload.originalInputFiles[0].location;
            this.fileDownloadService.downloadFileInputFile(fileUpload, inputFileLocation);
        } catch (e) {
            this.uiContext.handleError(e);
        }
    }

    private async uploadMeme(): Promise<FileUpload> {
        await this.initializeScriptsAndWebsockets();
        try {
            this.uiContext.successToast('Please wait wile we upload your meme.', '', 10000);
            const file = this.memeUploadService.canvastoFile(this.meme.getCanvasManager().getCanvas());
            const uniqueProcessType = (await this.pageDataProviderService.loadFeaturePageDataForProps(this.props).toPromise()).uniqueProcessType;
            const metadata = await this.processorResolverService.generateFileUploadRequestMetadata(file, ['image'], 'image', OperationTypes.UPLOAD);
            const fileWithMetadata = await UploadInProgressFileFactory.newUploadInProgressFile(
                file,
                metadata,
                uniqueProcessType,
            );
            const observerObject = {
                next: x => {
                    fileWithMetadata.setProgress(x);
                    // fileUpload.progress = x;
                },
                error: err => {
                    this.logger.error({ message: 'Error uploading meme.', error: err });
                    fileWithMetadata.setError();
                },
                complete: () => {
                    fileWithMetadata.setComplete();
                },
            };

            for (let attempt = 0; attempt <= 2; attempt++) {
                const isFinal = attempt === 2;
                const isFirst = attempt === 0;
                try {
                    await this.fileUploadService.uploadFileFromLocalDisk(fileWithMetadata, observerObject, {
                        suppressErrorDialog: !isFinal,
                        suppressGAStart: !isFirst,
                        suppressGAFailed: !isFinal,
                    }).then((originalInputFile: OriginalInputFile) => {
                        fileWithMetadata.setResponse(originalInputFile);
                    });
                    break;
                } catch (e) {
                    if (!ConnectivityUtils.isConnectivityError(e) || isFinal) throw e;
                    fileWithMetadata.setProgress(0);
                    const newMeta = await this.processorResolverService
                        .generateFileUploadRequestMetadata(file, ['image'], 'image',
                            OperationTypes.UPLOAD, { suppressGA: true });
                    fileWithMetadata.setMetadata(newMeta);
                }
            }
            const fileUpload = FileUploadUtils.toFileUpload(
                fileWithMetadata,
                this.websocketService.getId(),
                ProcessTypes.MEME,
                [FromTypes.IMAGE],
                'image',
                {},
                {} as any,
                'meme-generator',
            );
            return fileUpload;
        } catch (e) {
            throw e;
        }
    }

    async initializeScriptsAndWebsockets() {
        await this.spinner.runWithLoader(async () => {
            try {
                await this.scriptLoadService.loadAllScriptsIfNotLoaded();
            } catch (e) {
                this.logger.error({
                    error: e,
                    message: 'Something went wrong while loading scripts.',
                });
                this.uiContext.showErrorDialog(
                    {
                        title: 'Failed to initialize services!', text: 'Following services failed: ' +
                            this.scriptLoadService.getFailedScripts().join(', ') +
                            '. Please send us a screenshot to (support@xconvert.com).' +
                            ' Please try loading the page on Incognito Mode with plugins disabled.'
                    },
                );
            }
        }, 'Please wait while we initialize file upload service...');
    }

    @reloadAfterExecuteAsync()
    private async initializeMemeSample() {
        this.meme = new Meme(this.memeWidth);
        const memeImage1 = new MemeStoredImage('/meme/src/Batman-Slapping-Robin.jpg', this.meme);
        const texts = [
            {
                TYPE: 'MemeText',
                maxMaxFontSize: 40,
                fontSize: 30,
                fontGap: 15,
                hasLineWidth: false,
                fontColor: 'black',
                fontFamily: 'tahoma',
                textAlign: 'center',
                editPanelShown: false,
                capitalized: false,
                topOffset: 5,
                text: 'You can add more text \n like this by clicking on\n "Text" button on top',
                textLocation: {
                    width: 335,
                    x: 13,
                    y: 99.99998474121094,
                    z: 1,
                },
                id: 'x-9c10b010-a7bb-4b46-8bf9-41f313a88ce0',
                boundingRectangle: {
                    x: 13,
                    y: 99.99998474121094,
                    width: 335,
                    height: 130,
                },
            }, {
                TYPE: 'MemeText',
                maxMaxFontSize: 40,
                fontSize: 24,
                fontGap: 15,
                hasLineWidth: false,
                fontColor: 'black',
                fontFamily: 'verdana',
                textAlign: 'center',
                editPanelShown: false,
                capitalized: false,
                topOffset: 5,
                text: 'You can change/add\n more images by clicking on \n"+ Image" button...',
                textLocation: {
                    width: 306,
                    x: 380,
                    y: 111.99998474121094,
                    z: 1,
                },
                id: 'x-c14677fb-3997-42a0-b463-ae26f5994e42',
                boundingRectangle: {
                    x: 380,
                    y: 111.99998474121094,
                    width: 306,
                    height: 112,
                },
            }, {
                TYPE: 'MemeText',
                maxMaxFontSize: 40,
                fontSize: 31,
                fontGap: 15,
                hasLineWidth: true,
                fontColor: 'white',
                fontFamily: 'impact',
                textAlign: 'center',
                editPanelShown: false,
                capitalized: true,
                topOffset: 5,
                text: 'Funny Meme Title added to space above\nDouble click to edit...',
                textLocation: {
                    width: 700,
                    x: 4,
                    y: 1.993743896484375,
                    z: 1,
                },
                id: 'x-3e86288e-561e-44cf-8f0e-6dc94997997e',
                boundingRectangle: {
                    x: 4,
                    y: 1.993743896484375,
                    width: 700,
                    height: 87,
                },
            }];
        await Promise.all([this.meme.addImage(memeImage1)])
            .then(() => {
                const text = new MemeText(
                    `Double click for text editor.\n ...`,
                    { width: this.memeWidth, x: 0, y: 20, z: 1 },
                );
                Object.assign(text, texts[0]);
                this.meme.addText(text);

                const text2 = new MemeText(
                    `Double click for text editor.\n ...`,
                    { width: this.memeWidth, x: 0, y: 20, z: 1 },
                );
                Object.assign(text2, texts[1]);
                this.meme.addText(text2);

                const text3 = new MemeText(
                    `Double click for text editor.\n ...`,
                    { width: this.memeWidth, x: 0, y: 20, z: 1 },
                );
                Object.assign(text3, texts[2]);
                this.meme.addText(text3);

                const imageRewite = {
                    'loaded': true,
                    'border': { 'top': 93, 'bottom': 0 },
                    'bgColor': 'black',
                    'srcUrl': '/meme/src/Batman-Slapping-Robin.jpg',
                    'id': 'x-fbd80572-7ebd-4364-b844-605f9f5b9a66',
                    'boundingRectangle': { 'x': 0, 'y': 0, 'width': 700, 'height': 770.25 },
                };

                Object.assign(this.meme.images[0], imageRewite);

                this.meme.paint();
            });
        console.log(this.meme);
    }

    @reloadAfterExecute()
    toggleAddImagePanelFor(image) {
        this.addImagePanelShowForImage = this.addImagePanelShowForImage ? null : image;
    }

    getAddImagePanel(image: any) {
        return <div className={styles['meme-action-panel']}>
            <div className="d-flex justify-content-between align-items-center mb-2 pb-2 border-bottom">
                <span className="font-weight-bold text-dark small">Manage Image</span>
                <span className="text-muted small cursor-pointer" onClick={() => this.toggleAddImagePanelFor(image)}>
                    {IconHelper.getIconElement(HtmlEntityTypes.X_BOLD)}
                </span>
            </div>
            <button type="button" className="btn btn-outline-secondary w-100 mb-2 btn-sm text-left"
                onClick={() => { this.addImageAbove(image) }}>
                {IconHelper.getIconElement(HtmlEntityTypes.PLUS_BOLD)} Image Above
            </button>
            <button type="button" className="btn btn-outline-secondary w-100 mb-2 btn-sm text-left"
                onClick={() => { this.changeImage(image) }}>
                {IconHelper.getIconElement(HtmlEntityTypes.REDO)} Change Image
            </button>
            <button type="button" className="btn btn-outline-secondary w-100 mb-0 btn-sm text-left"
                onClick={() => { this.addImageBelow(image) }}>
                {IconHelper.getIconElement(HtmlEntityTypes.PLUS_BOLD)} Image Below
            </button>
        </div>
    }

    @reloadAfterExecute()
    toggleBorderPropertyPanelFor(image) {
        this.borderPropertyPanelShownForImage = this.borderPropertyPanelShownForImage ? null : image;
    }

    getBorderPropertyPanelFor(image: any) {
        return <div className={styles['meme-action-panel']}>
            <div className="d-flex justify-content-between align-items-center mb-2 pb-2 border-bottom">
                <span className="font-weight-bold text-dark small">Spacing & Border</span>
                <span className="text-muted small cursor-pointer" onClick={() => this.toggleBorderPropertyPanelFor(image)}>
                    {IconHelper.getIconElement(HtmlEntityTypes.X_BOLD)}
                </span>
            </div>

            <div className="mb-3">
                <label className="small text-muted mb-1">Border Color</label>
                <Dropdown
                    label="Border Color"
                    initialValue={this.colorsDropdownItems.find(a => a.selected)}
                    values={this.colorsDropdownItems}
                    onSelect={($event) => this.updateImageBorderColor(image, $event.item)}
                    valueFormatter={(v: any) => v && v.text}
                    hasTooltip={(v) => false}
                    getTooltip={(v) => null}
                    btnClassNames="btn btn-outline-secondary btn-sm w-100 text-left d-flex justify-content-between align-items-center"
                ></Dropdown>
            </div>

            <div className="bg-light p-2 rounded mb-2">
                <div className="d-flex justify-content-between">
                    <label htmlFor="rangeTop" className="small text-muted mb-1">Space Up</label>
                    <span className="small font-weight-bold">{image.getBorder().top}px</span>
                </div>
                <input type="range" className="custom-range w-100" id="rangeTop"
                    onInput={($event) => this.updateImageBorderTop($event, image)}
                    value={image.getBorder().top} min="0" max="1000" />
            </div>

            <div className="bg-light p-2 rounded">
                <div className="d-flex justify-content-between">
                    <label htmlFor="rangeBottom" className="small text-muted mb-1">Space Down</label>
                    <span className="small font-weight-bold">{image.getBorder().bottom}px</span>
                </div>
                <input type="range" className="custom-range w-100" id="rangeBottom"
                    onInput={($event) => this.updateImageBorderBottom($event, image)}
                    value={image.getBorder().bottom} min="0" max="1000" />
            </div>
        </div>;
    }

    render() {
        return <MotiveFrame>
            <div className={sharedStyles.wrapper}>
                <div style={{ width: '100%', maxWidth: '1200px' }}>
                    <div className="gcontent-container mb-3">
                        <MotiveComponent
                            data={AdSlots.pageTop}
                            location={MotiveLocationTypes.memePageTop} containerWidth="100%"
                            containerHeight="60px"
                            adWidth="970px" adHeight="90px" showAds={true} className='width_major'
                        ></MotiveComponent>
                    </div>

                    <div className="row nav-padding">
                        <div className="col-12">
                            <div className={`${sharedStyles.card} ${styles['meme-card']}`}>
                                {/* Title and Description */}
                                <div className="text-center mb-5">
                                    <h1 className="title" style={{ fontSize: '2.5rem', fontWeight: 700, marginBottom: '1rem', color: '#1e293b' }}>
                                        {this.title}
                                    </h1>
                                    <p className="description secondary-text" style={{ fontSize: '1.1rem', color: '#64748b', maxWidth: '80%', margin: '0 auto' }}>
                                        {this.description}
                                    </p>
                                </div>

                                {/* Toolbar area */}
                                <div className="d-flex align-items-center mb-4 pb-3 border-bottom gap-2 flex-wrap">
                                    <Tooltip text="Add New Text">
                                        <button type="button" className={sharedStyles.buttonSecondary} onClick={() => this.addNewText()}>
                                            {IconHelper.getIconElement(HtmlEntityTypes.PLUS_BOLD)} Text
                                        </button>
                                    </Tooltip>

                                    <Tooltip text="Add Clipart">
                                        <button type="button" className={sharedStyles.buttonSecondary} onClick={() => this.addClipArt()} >
                                            {IconHelper.getIconElement(HtmlEntityTypes.PLUS_BOLD)} Clipart
                                        </button>
                                    </Tooltip>

                                    <Tooltip text="Toggle Controllers">
                                        <button type="button" className={sharedStyles.buttonSecondary} onClick={() => this.toggleControls()}>
                                            {IconHelper.getIconElement(HtmlEntityTypes.DESKTOP_COMPUTER)} {(!this.controllersShown && <span>Show</span>) || <span>Hide</span>} Preview
                                        </button>
                                    </Tooltip>

                                    <div className="vr mx-1"></div>

                                    <Tooltip text="Share Meme">
                                        <button type="button" className={sharedStyles.buttonPrimary} onClick={() => this.shareMeme()} >
                                            {IconHelper.getIconElement(HtmlEntityTypes.ARROW_FORWARD)} Share
                                        </button>
                                    </Tooltip>
                                    <Tooltip text="Download Meme">
                                        <button type="button" className={sharedStyles.buttonPrimary} style={{ backgroundColor: '#10b981' }} onClick={() => this.downloadMeme()} >
                                            {IconHelper.getIconElement(HtmlEntityTypes.DOWNLOAD_TRAY)} Download
                                        </button>
                                    </Tooltip>
                                    <Tooltip text="Clear Meme">
                                        <button type="button" className={`${sharedStyles.buttonSecondary} text-danger`} style={{ borderColor: '#fee2e2', backgroundColor: '#fef2f2' }} onClick={() => this.clearMeme()} >
                                            {IconHelper.getIconElement(HtmlEntityTypes.TRASH_BIN)} Clear
                                        </button>
                                    </Tooltip>
                                </div>

                                {/* Canvas Area */}
                                <div className="d-flex justify-content-center bg-dark rounded p-1 p-md-4 mb-3 position-relative meme-wrapper-col" style={{ minHeight: '500px', overflow: 'hidden' }}>
                                    <div style={{
                                        width: (this.memeWidth * this.scale) + 'px',
                                        height: (this.meme ? this.meme.getMemeDimension().height * this.scale : 500) + 'px',
                                        position: 'relative'
                                    }}>
                                        <div className={`canvas-container ${styles['canvas-container']}`} style={{
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            transform: `scale(${this.scale})`,
                                            transformOrigin: 'top left'
                                        }}>
                                            <canvas id="canvas"></canvas>
                                            {
                                                (this.meme ? this.meme.getSortedGraphics('ClipArt') : []).map((graphic: any) => {
                                                    return <div
                                                        key={graphic.id}
                                                        id={graphic.id}
                                                        className={`${styles['graphc-container']} ${styles['graphic-container-parent']} ${!this.controllersShown ? styles["container-invisible"] : ''}`}
                                                        style={{
                                                            width: graphic.boundingRectangle.width,
                                                            height: graphic.boundingRectangle.height,
                                                            left: graphic.getLocation().x,
                                                            top: graphic.getLocation().y,
                                                        }}
                                                    >

                                                        <div className={styles['container-event-handler']} onMouseDown={($event) => this.mouseDown($event as any, graphic, MouseEventTypes.MOVE)}

                                                            onTouchStart={($event: any) => this.mouseDown($event, graphic, MouseEventTypes.MOVE)}
                                                            onDoubleClick={($event) => this.updateEditMode($event, graphic)}></div>

                                                        <div
                                                            className={`${styles['handler']} ${styles['resize-handler']} ${!this.controllersShown ? styles['control-hidden'] : ''}`}
                                                            id={'rh' + graphic.id}
                                                            onMouseDown={($event) => this.mouseDown($event as any, graphic, MouseEventTypes.RESIZE)}
                                                            onTouchStart={($event: any) => this.mouseDown($event, graphic, MouseEventTypes.RESIZE)}

                                                        >
                                                            {IconHelper.getIconElement(HtmlEntityTypes.ARROW_LEFT_RIGHT)}

                                                        </div>

                                                        <div
                                                            id={'dt' + graphic.id}
                                                            className={`${styles['handler']} ${styles['delete-text static-handler']} ${!this.controllersShown ? styles['control-hidden'] : ''}`}
                                                            onClick={($event) => this.deleteGraphic(graphic)} >
                                                            {IconHelper.getIconElement(HtmlEntityTypes.PENSIL)}
                                                        </div>

                                                        <div
                                                            className={`rotate-handler hidden-feature ${styles['rotate-handler']} ${styles['hidden-feature']}`}
                                                            onClick={($event) => this.suppressEvent($event as any)}
                                                            onMouseDown={($event) => this.mouseDown($event as any, graphic, MouseEventTypes.ROTATE)}
                                                        >
                                                            {IconHelper.getIconElement(HtmlEntityTypes.UNDO)}
                                                        </div>

                                                    </div>
                                                })
                                            }

                                            {
                                                (this.meme ? this.meme.getSortedGraphics('MemeText') : []).map((text: any) => {
                                                    let colorsDropdownItems = this.dropdownItemsCache.get('fontColor' + text.id);
                                                    let fontsDropdownItems = this.dropdownItemsCache.get('fontFamily' + text.id);
                                                    if (!colorsDropdownItems) {
                                                        colorsDropdownItems = cloneDeep(this.colorsDropdownItems);
                                                        this.dropdownItemsCache.set('fontColor' + text.id, colorsDropdownItems);
                                                    }
                                                    if (!fontsDropdownItems) {
                                                        fontsDropdownItems = cloneDeep(this.fontsDropdownItems);
                                                        this.dropdownItemsCache.set('fontFamily' + text.id, fontsDropdownItems);
                                                    }
                                                    colorsDropdownItems.forEach(i => { i.selected = i.item === text.fontColor });
                                                    fontsDropdownItems.forEach(i => { i.selected = i.item === text.fontFamily });

                                                    const isNearTop = text.getLocation().y < 250;
                                                    const positionStyle = isNearTop
                                                        ? { top: text.boundingRectangle.height + 10 }
                                                        : { bottom: text.boundingRectangle.height + 10 };

                                                    return <div
                                                        id={text.id}
                                                        key={text.id}
                                                        className={`${styles['graphic-container-parent']} ${styles['text-container-parent']} 
                                        ${!this.controllersShown ? styles["container-invisible"] : ''}
                                        ${text.editPanelShown ? styles["editor-shown"] : ''}
                                        `}
                                                        style={{
                                                            width: text.boundingRectangle.width,
                                                            height: text.boundingRectangle.height,
                                                            left: text.getLocation().x,
                                                            top: text.getLocation().y,
                                                        }}
                                                    >

                                                        <div className={styles['container-event-handler']} onMouseDown={($event) => this.mouseDown($event as any, text, MouseEventTypes.MOVE)}

                                                            onTouchStart={($event: any) => this.mouseDown($event, text, MouseEventTypes.MOVE)}
                                                            onDoubleClick={($event) => this.updateEditMode($event, text)}></div>

                                                        <div style={positionStyle}
                                                            className={`${styles['level100']} ${styles['text-editor']} ${!text.editPanelShown ? "hidden" : ''} ${!this.controllersShown ? styles["control-hidden"] : ''}`}
                                                        >
                                                            {/* Header */}
                                                            <div className="d-flex justify-content-between align-items-center mb-3 pb-2 border-bottom">
                                                                <span className="font-weight-bold text-dark">Edit Text</span>
                                                                <div className="d-flex gap-3">
                                                                    <button type="button" className="btn btn-sm btn-outline-danger border-0 p-1" onClick={() => this.deleteText(text)} title="Delete Text">
                                                                        {IconHelper.getIconElement(HtmlEntityTypes.TRASH_BIN)}
                                                                    </button>
                                                                    <button type="button" className="btn btn-sm btn-light border-0 p-1" onClick={($event) => this.updateEditMode($event, text)} title="Close">
                                                                        {IconHelper.getIconElement(HtmlEntityTypes.X_BOLD)}
                                                                    </button>
                                                                </div>
                                                            </div>

                                                            {/* Controls */}
                                                            <div className="d-flex flex-column gap-3 mb-3">
                                                                {/* Row 1: Font & Color */}
                                                                <div className="d-flex gap-2">
                                                                    <div className="flex-grow-1">
                                                                        <Dropdown
                                                                            initialValue={fontsDropdownItems.find(a => a.selected)}
                                                                            values={fontsDropdownItems}
                                                                            onSelect={($event) => this.updateTextFamily(text, $event.item)}
                                                                            valueFormatter={(v: any) => v && v.text}
                                                                            hasTooltip={(v) => false}
                                                                            getTooltip={(v) => null}
                                                                            btnClassNames="btn btn-outline-secondary btn-sm w-100 text-left d-flex justify-content-between align-items-center"
                                                                        ></Dropdown>
                                                                    </div>
                                                                    <div>
                                                                        <Dropdown
                                                                            initialValue={colorsDropdownItems.find(a => a.selected)}
                                                                            values={colorsDropdownItems}
                                                                            onSelect={($event) => this.updateTextColor(text, $event.item)}
                                                                            valueFormatter={(v: any) => v && v.text}
                                                                            hasTooltip={(v) => false}
                                                                            getTooltip={(v) => null}
                                                                            btnClassNames="btn btn-outline-secondary btn-sm"
                                                                        ></Dropdown>
                                                                    </div>
                                                                </div>

                                                                {/* Row 2: Alignment & Toggles */}
                                                                <div className="d-flex justify-content-between align-items-center">
                                                                    <div className="btn-group btn-group-sm">
                                                                        <button type="button" className={`btn ${text.getAlignment() === TextAlignTypes.LEFT ? 'btn-secondary' : 'btn-outline-secondary'}`}
                                                                            onClick={($event) => this.updateTextAlign(text, TextAlignTypes.LEFT)}>
                                                                            L
                                                                        </button>
                                                                        <button type="button" className={`btn ${text.getAlignment() === TextAlignTypes.CENTER ? 'btn-secondary' : 'btn-outline-secondary'}`}
                                                                            onClick={($event) => this.updateTextAlign(text, TextAlignTypes.CENTER)}>
                                                                            C
                                                                        </button>
                                                                        <button type="button" className={`btn ${text.getAlignment() === TextAlignTypes.RIGHT ? 'btn-secondary' : 'btn-outline-secondary'}`}
                                                                            onClick={($event) => this.updateTextAlign(text, TextAlignTypes.RIGHT)}>
                                                                            R
                                                                        </button>
                                                                    </div>

                                                                    <div className="d-flex gap-2">
                                                                        <button type="button"
                                                                            className={`btn btn-sm ${text.hasLineWidth ? "btn-dark" : "btn-outline-secondary"}`}
                                                                            onClick={() => this.toggleLineWidth(text)}>
                                                                            Stroke
                                                                        </button>
                                                                        <button type="button"
                                                                            className={`btn btn-sm ${text.getCapitalized() ? "btn-dark" : "btn-outline-secondary"}`}
                                                                            onClick={() => this.capitalizeText(text)}>
                                                                            CAPS
                                                                        </button>
                                                                    </div>
                                                                </div>

                                                                {/* Row 3: Sliders Buttons */}
                                                                <div className="d-flex gap-2">
                                                                    <button type="button" className={`btn btn-sm flex-fill ${this.drawerType === 'FONT_SIZE' ? 'btn-primary' : 'btn-outline-secondary'}`}
                                                                        onClick={($event) => this.showDrawerFor('FONT_SIZE')}>
                                                                        Size
                                                                    </button>
                                                                    <button type="button" className={`btn btn-sm flex-fill ${this.drawerType === 'FONT_GAP' ? 'btn-primary' : 'btn-outline-secondary'}`}
                                                                        onClick={($event) => this.showDrawerFor('FONT_GAP')}>
                                                                        Gap
                                                                    </button>
                                                                </div>

                                                                {/* Active Slider Area */}
                                                                {
                                                                    this.drawerType && <div className="bg-light p-2 rounded">
                                                                        <label htmlFor="formControlRange" className="small text-muted mb-1 block">
                                                                            {this.drawerType === 'FONT_SIZE' ? 'Font Size' : 'Font Gap'}: {this.drawerType === 'FONT_SIZE' ? text.getMaxFontSize() : text.getFontGap()}
                                                                        </label>
                                                                        <input type="range" className="custom-range w-100" id="formControlRange"
                                                                            min={this.drawerType === 'FONT_SIZE' ? "10" : "0"}
                                                                            max={this.drawerType === 'FONT_SIZE' ? "200" : "100"}
                                                                            onInput={($event) => this.fontPropertyChanged($event, text)}
                                                                            value={this.drawerType === 'FONT_SIZE' ? text.getMaxFontSize() : text.getFontGap()} />
                                                                    </div>
                                                                }
                                                            </div>

                                                            <textarea
                                                                className="form-control form-control-sm"
                                                                rows={2}
                                                                style={{ resize: 'none', fontSize: '1rem' }}
                                                                onKeyUp={($event) => this.contentChanged($event as any, text)}>{text.text}</textarea>

                                                        </div>
                                                        <div
                                                            className={`${styles['handler']} ${styles['resize-handler']} ${!this.controllersShown ? styles["control-hidden"] : ''}`}
                                                            id={'rh' + text.id}
                                                            onMouseDown={($event) => this.mouseDown($event as any, text, MouseEventTypes.RESIZE)}
                                                            onTouchStart={($event: any) => this.mouseDown($event, text, MouseEventTypes.RESIZE)}


                                                        >
                                                            {IconHelper.getIconElement(HtmlEntityTypes.ARROW_LEFT_RIGHT)}
                                                        </div>

                                                        <div
                                                            id={'te' + text.id}
                                                            className={`${styles['handler']} ${styles['toggle-edit']} ${styles['static-handler']} ${!this.controllersShown ? styles["control-hidden"] : ''} ${!text.editPanelShown ? styles["selected"] : ''}`}
                                                            onClick={($event) => this.updateEditMode($event, text)}
                                                        >

                                                            {IconHelper.getIconElement(HtmlEntityTypes.PENSIL)}
                                                        </div>

                                                        <div
                                                            id={'dt' + text.id} onClick={() => this.deleteText(text)}
                                                            className={`${styles['handler']} ${styles['delete-text']} ${styles['static-handler']} ${!this.controllersShown ? styles["control-hidden"] : ''}`}
                                                        >
                                                            {IconHelper.getIconElement(HtmlEntityTypes.TRASH_BIN)}
                                                        </div>

                                                    </div>
                                                })
                                            }

                                            {
                                                (this.meme ? this.meme.getImages() : []).map((image: any, index) => {
                                                    const border = image.getBorder();
                                                    const hasActivePanel = this.borderPropertyPanelShownForImage === image || this.addImagePanelShowForImage === image;
                                                    return <div
                                                        key={image.id}
                                                        id={image.id}
                                                        className={`${styles['graphic-container-parent']} ${styles['image-container']} ${hasActivePanel ? styles['on-top'] : ''}`}
                                                        style={{
                                                            width: image.width,
                                                            height: image.boundingRectangle.height,
                                                            left: image.boundingRectangle.x,
                                                            top: image.boundingRectangle.y,
                                                        }}
                                                    >
                                                        <div className={`${styles['image-container']}`} style={{ bottom: image.boundingRectangle.height }}>
                                                            <div className={`${styles['image-handles']} ${!this.controllersShown ? styles["control-hidden"] : ''}`}>
                                                                <div className={`${styles['image-actions']}`}>
                                                                    <div>
                                                                        {
                                                                            this.borderPropertyPanelShownForImage && this.getBorderPropertyPanelFor(image)
                                                                        }
                                                                        <button type="button" className="btn btn-info btn-sm" onClick={() => this.toggleBorderPropertyPanelFor(image)}
                                                                        >
                                                                            {
                                                                                this.borderPropertyPanelShownForImage ?
                                                                                    IconHelper.getIconElement(HtmlEntityTypes.MINUS) :
                                                                                    IconHelper.getIconElement(HtmlEntityTypes.PLUS_BOLD)
                                                                            } Space
                                                                        </button>
                                                                    </div>
                                                                    <div>
                                                                        {
                                                                            this.addImagePanelShowForImage && this.getAddImagePanel(image)
                                                                        }
                                                                        {
                                                                            index !== ((this.meme ? this.meme.getImages() : []).length - 1) && <button type="button"
                                                                                className="btn btn-secondary btn-sm" onClick={() => this.moveImageDown(image)}>
                                                                                {IconHelper.getIconElement(HtmlEntityTypes.ARROW_DOWN)}
                                                                            </button>
                                                                        }
                                                                        <button type="button" className="btn btn-info btn-sm" onClick={() => this.toggleAddImagePanelFor(image)}>
                                                                            {
                                                                                this.addImagePanelShowForImage ?
                                                                                    IconHelper.getIconElement(HtmlEntityTypes.MINUS) :
                                                                                    IconHelper.getIconElement(HtmlEntityTypes.PLUS_BOLD)
                                                                            }
                                                                            Image
                                                                        </button>
                                                                        {
                                                                            index !== 0 && <button type="button" className="btn btn-secondary btn-sm"
                                                                                onClick={() => this.moveImageUp(image)}>
                                                                                {IconHelper.getIconElement(HtmlEntityTypes.ARROW_UP)}
                                                                            </button>
                                                                        }

                                                                        <button type="button" className="btn btn-secondary btn-sm" onClick={() => this.deleteImage(image)}>
                                                                            {IconHelper.getIconElement(HtmlEntityTypes.TRASH_BIN)}
                                                                        </button>
                                                                    </div>
                                                                    <div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                })
                                            }


                                        </div>
                                    </div>
                                </div>
                                {
                                    this.features && (
                                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 mt-3">
                                            <FeaturesTilesComponent features={this.features}></FeaturesTilesComponent>
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </MotiveFrame>
    }
}
